import PropTypes from 'prop-types';
import React from 'react';
import { DangerousHTMLDiv } from '../../DangerousHTML/DangerousHTMLDiv';

export class Header extends React.Component {
  render() {
    return (
      <div className="question-area header form-group d-none d-lg-table-row">
        <div className="cell"></div>
        {
            this.props.listAnswers.map(answer => (
              <div className="cell" key={answer.listAnswerId}>
                <DangerousHTMLDiv html={answer.formattedText} />
              </div>
            ))
        }
      </div>
    );
  }
}

Header.propTypes = {
  listAnswers: PropTypes.array,
};
